var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.954 473.954",
    style: {
      enableBackground: "new 0 0 473.954 473.954"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4ABC96"
    },
    cx: 236.988,
    cy: 236.975,
    r: 236.966
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357180"
    },
    d: "M49.081,126.095v-18.761H38.63c-3.772,5.759-7.323,11.671-10.589,17.766L49.081,126.095z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#357180"
    },
    points: "167.657,121.893 167.657,107.334 79.756,107.334 79.756,126.066  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357180"
    },
    d: "M335.221,107.334H232.404v11.487l79.666-3.779v11.768h10.237v331.228 c7.001-2.705,13.833-5.721,20.497-9.048V114.915C342.805,110.743,339.411,107.334,335.221,107.334z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27636D"
    },
    points: "64.074,126.814 79.756,126.066 79.756,107.334 49.081,107.334 49.081,126.095 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7BF"
    },
    d: "M322.311,458.038V126.814h-10.237v334.91C315.52,460.568,318.933,459.348,322.311,458.038z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M49.081,126.814v-0.715l-21.04-0.995c-0.307,0.561-0.58,1.141-0.876,1.71H49.081z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "49.634,126.814 64.074,126.814 49.081,126.095 49.081,126.814  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M27.165,126.814c-6.975,13.257-12.733,27.236-17.122,41.833l26.428,0.842 c4.46,0.146,8.086,4.026,8.086,8.673c0,4.647-3.626,8.295-8.086,8.15l-30.765-0.98c-1.283,5.766-2.376,11.607-3.229,17.526 l33.994,1.089c4.46,0.146,8.086,4.019,8.086,8.666c0,4.647-3.626,8.303-8.086,8.157L0.7,219.628 c-0.4,5.497-0.666,11.034-0.685,16.632l36.452,1.171c4.46,0.138,8.086,4.019,8.086,8.666c0,4.647-3.626,8.303-8.086,8.157 l-35.861-1.152c0.4,5.957,1.003,11.861,1.833,17.687l34.031,1.089c4.46,0.146,8.086,4.019,8.086,8.658 c0,4.655-3.626,8.31-8.086,8.165l-30.967-0.988c1.351,6.174,2.915,12.277,4.741,18.264l26.23,0.842 c4.46,0.146,8.086,4.019,8.086,8.666c0,4.64-3.626,8.296-8.086,8.15l-20.299-0.651c2.369,6.08,4.943,12.06,7.79,17.874l12.509,0.4 c4.46,0.146,8.086,4.034,8.086,8.666c0,4.647-3.626,8.295-8.086,8.15l-3.233-0.101c4.823,8.105,10.121,15.88,15.843,23.319V126.814 H27.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M49.634,126.814h-0.55v254.485c0.183,0.236,0.37,0.468,0.55,0.703V126.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M49.634,381.998c4.157,5.366,8.516,10.559,13.115,15.543V135.267h1.325v-8.456H49.634V381.998z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "167.657,126.814 167.657,121.893 79.756,126.066 79.756,126.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "312.07,126.814 312.07,115.046 232.404,118.825 232.404,126.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "79.756,126.814 79.756,126.066 64.074,126.814 79.191,126.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "214.93,337.366 206.373,320.008 197.73,320.289 187.451,338.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E7D6"
    },
    points: "167.919,372.359 231.181,370.343 223.091,353.927 177.648,355.376  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M232.404,165.032l52.1-1.665c4.464-0.146,8.082,3.502,8.082,8.157c0,4.647-3.618,8.52-8.082,8.673 l-52.1,1.658v17.635l52.1-1.665c4.464-0.146,8.082,3.502,8.082,8.15s-3.618,8.527-8.082,8.673l-52.1,1.665v16.655l52.1-1.658 c4.464-0.153,8.082,3.502,8.082,8.15s-3.618,8.52-8.082,8.666l-52.1,1.665v17.635l52.1-1.665c4.464-0.146,8.082,3.495,8.082,8.142 s-3.618,8.535-8.082,8.681l-52.1,1.665v18.118l52.1-1.665c4.464-0.146,8.082,3.502,8.082,8.15c0,4.632-3.618,8.52-8.082,8.666 l-52.1,1.658v17.635l52.1-1.665c4.464-0.146,8.082,3.51,8.082,8.15c0,4.647-3.618,8.52-8.082,8.666l-52.1,1.665v16.67l52.1-1.658 c4.464-0.153,8.082,3.502,8.082,8.142s-3.618,8.527-8.082,8.673L93.039,391.57c-4.46,0.146-8.075-3.51-8.075-8.157 c0-4.64,3.615-8.52,8.075-8.658l74.614-2.391v-16.67l-74.614,2.384c-4.46,0.146-8.075-3.502-8.075-8.15 c0-4.632,3.615-8.52,8.075-8.666l74.614-2.384v-17.635l-74.614,2.391c-4.46,0.146-8.075-3.51-8.075-8.15 c0-4.647,3.615-8.52,8.075-8.666l74.614-2.384v-18.118l-74.614,2.384c-4.46,0.146-8.075-3.51-8.075-8.165 c0-4.64,3.615-8.513,8.075-8.658l74.614-2.383V251.86l-74.614,2.391c-4.46,0.146-8.075-3.51-8.075-8.157 c0-4.647,3.615-8.527,8.075-8.666l74.614-2.391v-16.655l-74.614,2.383c-4.46,0.146-8.075-3.51-8.075-8.157s3.615-8.52,8.075-8.666 l74.614-2.383v-17.635l-74.614,2.383c-4.46,0.146-8.075-3.502-8.075-8.15c0-4.647,3.615-8.527,8.075-8.673l74.614-2.383v-40.287 H79.756v287.401c1.747,1.549,3.506,3.091,5.298,4.591c-0.034-0.314-0.09-0.614-0.09-0.935c0-4.632,3.615-8.52,8.075-8.666 l191.466-6.118c4.464-0.146,8.082,3.51,8.082,8.142c0,4.655-3.618,8.527-8.082,8.673L94.072,425.99 c39.73,30.08,89.222,47.954,142.898,47.954c26.26,0,51.494-4.333,75.097-12.221v-334.91h-79.662V165.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M79.191,413.721c0.187,0.168,0.382,0.322,0.565,0.49V126.814h-0.565V413.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7D6"
    },
    d: "M66.072,135.267v265.759c4.217,4.393,8.58,8.64,13.119,12.696V126.814H64.074v8.456h1.998V135.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCDDD8"
    },
    d: "M64.074,135.267h-1.325v262.275c0.434,0.475,0.887,0.92,1.325,1.388V135.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCDDD8"
    },
    d: "M66.072,401.029V135.267h-1.998V398.93C64.736,399.641,65.402,400.333,66.072,401.029z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,178.158c0-4.647-3.626-8.527-8.086-8.673l-26.428-0.842 c-1.643,5.474-3.079,11.042-4.333,16.685l30.765,0.98C40.931,186.454,44.557,182.806,44.557,178.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,212.609c0-4.647-3.626-8.52-8.086-8.666l-33.994-1.089 c-0.797,5.534-1.369,11.132-1.777,16.771l35.771,1.141C40.931,220.912,44.557,217.256,44.557,212.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,246.094c0-4.647-3.626-8.527-8.086-8.666l-36.452-1.171C0.015,236.496,0,236.724,0,236.96 c0,5.437,0.247,10.802,0.606,16.142l35.865,1.149C40.931,254.397,44.557,250.745,44.557,246.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,280.54c0-4.64-3.626-8.513-8.086-8.658L2.44,270.793c0.819,5.714,1.848,11.349,3.061,16.924 l30.967,0.988C40.931,288.847,44.557,285.195,44.557,280.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,315.485c0-4.647-3.626-8.52-8.086-8.666l-26.23-0.842 c1.755,5.774,3.753,11.431,5.931,17.006l20.299,0.651C40.931,323.78,44.557,320.128,44.557,315.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M44.557,349.928c0-4.632-3.626-8.52-8.086-8.666l-12.509-0.4c2.859,5.852,5.961,11.555,9.276,17.115 l3.233,0.101C40.931,358.223,44.557,354.579,44.557,349.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,169.485c-4.46,0.146-8.075,4.026-8.075,8.673c0,4.647,3.615,8.295,8.075,8.15l74.614-2.384 v-16.823L93.039,169.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,180.198c4.464-0.153,8.082-4.026,8.082-8.673c0-4.655-3.618-8.303-8.082-8.157l-52.1,1.665 v16.823L284.505,180.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,214.648c4.464-0.146,8.082-4.026,8.082-8.673s-3.618-8.295-8.082-8.15l-52.1,1.665v16.823 L284.505,214.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,203.943c-4.46,0.146-8.075,4.019-8.075,8.666c0,4.647,3.615,8.303,8.075,8.157l74.614-2.383 v-16.823L93.039,203.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,237.428c-4.46,0.138-8.075,4.019-8.075,8.666c0,4.647,3.615,8.303,8.075,8.157l74.614-2.391 v-16.823L93.039,237.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,248.125c4.464-0.146,8.082-4.019,8.082-8.666s-3.618-8.303-8.082-8.15l-52.1,1.661v16.823 L284.505,248.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,282.583c4.464-0.146,8.082-4.034,8.082-8.681s-3.618-8.288-8.082-8.142l-52.1,1.665v16.823 L284.505,282.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,271.878c-4.46,0.146-8.075,4.019-8.075,8.658c0,4.655,3.615,8.31,8.075,8.165l74.614-2.384 v-16.823L93.039,271.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,317.516c4.464-0.146,8.082-4.034,8.082-8.666c0-4.647-3.618-8.296-8.082-8.15l-52.1,1.665 v16.808L284.505,317.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,306.819c-4.46,0.146-8.075,4.019-8.075,8.666c0,4.64,3.615,8.296,8.075,8.15l74.614-2.391 v-16.808L93.039,306.819z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B9B9BA"
    },
    points: "202.448,312.042 197.73,320.289 206.373,320.008  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,351.959c4.464-0.146,8.082-4.019,8.082-8.666c0-4.64-3.618-8.295-8.082-8.15l-52.1,1.665 v16.815L284.505,351.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,341.262c-4.46,0.146-8.075,4.034-8.075,8.666c0,4.647,3.615,8.296,8.075,8.15l74.614-2.384 v-16.815L93.039,341.262z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B9B9BA"
    },
    points: "177.648,355.376 223.091,353.927 214.93,337.366 187.451,338.242  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M231.181,370.343l-63.262,2.017l-0.262,0.468v-0.46l-74.614,2.391 c-4.46,0.138-8.075,4.019-8.075,8.658c0,4.647,3.615,8.303,8.075,8.157l191.466-6.118c4.464-0.146,8.082-4.034,8.082-8.673 s-3.618-8.295-8.082-8.142l-52.1,1.658v2.529L231.181,370.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M93.039,426.013l1.033-0.03c-3.064-2.324-6.069-4.722-9.018-7.184 C85.51,422.989,88.889,426.155,93.039,426.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9BA"
    },
    d: "M284.505,419.898c4.464-0.146,8.082-4.019,8.082-8.673c0-4.632-3.618-8.288-8.082-8.142 l-191.466,6.118c-4.46,0.146-8.075,4.034-8.075,8.666c0,0.322,0.06,0.621,0.09,0.935c2.949,2.462,5.953,4.861,9.018,7.184 L284.505,419.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.657,
    y: 107.188,
    style: {
      fill: "#BB5538"
    },
    width: 64.751,
    height: 0.146
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "232.404,118.825 232.404,107.334 167.657,107.334 167.657,121.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,126.814 232.404,126.814 232.404,118.825 167.657,121.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "197.73,320.289 167.657,321.243 167.657,338.878 187.451,338.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "232.404,165.032 232.404,126.814 167.657,126.814 167.657,167.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,235.037 232.404,232.971 232.404,216.313 167.657,218.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,269.495 232.404,267.429 232.404,249.794 167.657,251.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,201.559 232.404,199.49 232.404,181.855 167.657,183.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "214.93,337.366 232.404,336.813 232.404,319.178 206.373,320.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "177.648,355.376 167.657,355.694 167.657,372.367 167.919,372.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,304.435 232.404,302.366 232.404,284.252 167.657,286.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "231.181,370.343 232.404,370.298 232.404,353.628 223.091,353.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,183.924 232.404,181.855 232.404,165.032 167.657,167.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,218.382 232.404,216.313 232.404,199.49 167.657,201.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,251.86 232.404,249.794 232.404,232.971 167.657,235.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,286.318 232.404,284.252 232.404,267.429 167.657,269.495  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.657,321.243 197.73,320.289 202.448,312.042 206.373,320.008 232.404,319.178  232.404,302.366 167.657,304.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "223.091,353.927 232.404,353.628 232.404,336.813 214.93,337.366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "187.451,338.242 167.657,338.878 167.657,355.694 177.648,355.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "167.919,372.359 167.657,372.367 167.657,372.827  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BB5538"
    },
    points: "232.404,372.827 232.404,370.298 231.181,370.343  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.962c868da18ab4c4ba1eabd6d2bd82b6.svg";
export { ForwardRef as ReactComponent };